import { render, staticRenderFns } from "./DashboardProject.vue?vue&type=template&id=bf3e50cc&scoped=true&"
import script from "./DashboardProject.vue?vue&type=script&lang=js&"
export * from "./DashboardProject.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProject.vue?vue&type=style&index=0&id=bf3e50cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3e50cc",
  null
  
)

export default component.exports